/**
 * An object containing properties for a filterable query, used when filterType is 'select'
 */
var FilterQuery = /** @class */ (function () {
    function FilterQuery() {
    }
    return FilterQuery;
}());
export { FilterQuery };
//# sourceMappingURL=filter-query.js.map